module.exports = __webpack_public_path__ + "media/images/google-certified-logo-6c9be1f5638b642a920a8d40cef6742d.jpg";